function initImageCarousel(carousel) {

    if (carousel.dataset.initialized === 'true') {
        return;
    }

    const slides = Array.from(
        carousel.querySelectorAll(
            '[data-image-carousel-slide]'
        )
    );

    if (slides.length <= 1) {
        return;
    }

    carousel.dataset.initialized = 'true';

    let current = 0;

    window.setInterval(() => {

        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');

        current = (current + 1) % slides.length;

        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');

    }, 5000);

}


/* Front end */

document
    .querySelectorAll('[data-image-carousel]')
    .forEach(initImageCarousel);


/* ACF editor */

if (window.acf) {

    window.acf.addAction(
        'render_block_preview/type=image-carousel',
        ($block) => {

            $block
                .find('[data-image-carousel]')
                .each(function () {
                    initImageCarousel(this);
                });

        }
    );

}